import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import ThemeToggle from './components/ThemeToggle';
import './AuthPage.css';

function Register() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');

    // Validation
    if (password !== confirmPassword) {
      setError('Passwörter stimmen nicht überein');
      return;
    }

    if (password.length < 8) {
      setError('Passwort muss mindestens 8 Zeichen lang sein');
      return;
    }

    setLoading(true);
    const result = await register(email, password);

    if (result.success) {
      navigate('/');
    } else {
      setError(result.error);
    }
    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-theme-toggle">
        <ThemeToggle />
      </div>

      <div className="auth-container">
        <div className="auth-brand">
          <h1>Frankenfalter</h1>
          <p>Ihr persönlicher Vermögenstracker</p>
        </div>

        <div className="auth-card">
          <h2>Konto erstellen</h2>

          {error && (
            <div className="auth-error">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="12" cy="12" r="10" />
                <line x1="12" y1="8" x2="12" y2="12" />
                <line x1="12" y1="16" x2="12.01" y2="16" />
              </svg>
              {error}
            </div>
          )}

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label>E-Mail-Adresse</label>
              <input
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                autoFocus
                placeholder="ihre.email@beispiel.ch"
              />
            </div>

            <div className="form-group">
              <label>Passwort</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                placeholder="Mindestens 8 Zeichen"
              />
            </div>

            <div className="form-group">
              <label>Passwort bestätigen</label>
              <input
                type="password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
                required
                placeholder="Passwort wiederholen"
              />
            </div>

            <button
              type="submit"
              className="auth-submit-btn"
              disabled={loading}
            >
              {loading ? 'Konto wird erstellt...' : 'Konto erstellen'}
            </button>

            <div className="auth-link">
              Bereits ein Konto?{' '}
              <Link to="/login">
                Jetzt anmelden
              </Link>
            </div>

            <div style={{
              textAlign: 'center',
              marginTop: 'var(--space-6)',
              fontSize: 'var(--font-size-xs)',
              color: 'var(--text-tertiary)'
            }}>
              Mit der Registrierung akzeptieren Sie unsere{' '}
              <Link
                to="/datenschutz"
                style={{
                  color: 'var(--text-tertiary)',
                  textDecoration: 'underline'
                }}
              >
                Datenschutzerklärung
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default Register;
